import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { CartAdd, CartRmv } from "../../store/actions/CartActions"
import { calculateDiscountPercentage } from '../helpers/helpers'
import SwiperCTNProducts from "../layouts/SwiperCTNProducts"
import { productsPublicShop } from "../../services/ProductService"
import { createCustomer } from "../../store/actions/customerActions"
//import logo from "../../images/logo-ald.png"
import logo from "../../images/logo-full.png"
import superkeroexplica from "../../images/super-kero-explica.png"
import ReCAPTCHA from 'react-google-recaptcha';
import { loadingToggleAction, loginAction } from '../../store/actions/AuthActions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const MenuOut = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const userDetails = localStorage.getItem('userDetails');
        if (userDetails) {
            navigate('/');
        }
    }, [navigate]);

    let dummy = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')) : {
        cart: {
            loja: "",
            status: "aguardando",
            itens: []
        }
    }
    let cartToken = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')) : { cart: {} }

    const [loading, setLoading] = useState(true)
    const [shopper, setShopper] = useState({});
    const [isBuying, setIsBuying] = useState(false);
    const [products, setProducts] = useState([])
    const [product, setProduct] = useState({})
    const [shopperId, setShopperId] = useState('-')
    const [qtd, setQtd] = useState(0);
    const [lojaSelecionada, setLojaSelecionada] = useState(cartToken.cart.loja);
    const [modalShow, setModalShow] = useState(false);
    const [modalProduct, setModalProduct] = useState(false);
    const [cart, setCart] = useState(dummy);
    const [isLargeScreen,] = useState(window.innerWidth > 700);

    const [productNameSearch, setProductNameSearch] = useState('');
    const [onSearch, setOsSearch] = useState(false);
    const [lastSearch, setLastSearch] = useState('');
    const [searchSteps, setSearchSteps] = useState('name');
    const [modalSearch, setModalSearch] = useState(false);
    const [searchValueType, setValueType] = useState('name');

    const [modalAuth, setModalAuth] = useState(false);
    const [authStep, setAuthStep] = useState('initial');
    const [loginData, setLoginData] = useState({
        username: '',
        password: ''
    });
    const [registerData, setRegisterData] = useState({
        name: '',
        email: 'email@email.com',
        phone: '',
        taxId: '',
        username: '',
        password: '',
        birthDate: '', // Adicionando campo de data de nascimento
        address: {
            number: '',
            street: '',
            city: '',
            state: '',
            zipcode: ''
        }
    });
    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const [formattedData, setFormattedData] = useState({
        phone: '',
        taxId: '',
        zipcode: ''
    });

    const [isFormValid, setIsFormValid] = useState(false);

    const formRef = useRef(null);
    const [showScrollButton, setShowScrollButton] = useState(false);

    const [registerStatus, setRegisterStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const [cpfValid, setCpfValid] = useState(true);

    const [whatsPhone, setWhatsPhone] = useState('');
    const [whatsLoading, setWhatsLoading] = useState(false);
    const [whatsSuccess, setWhatsSuccess] = useState(false);
    const [whatsError, setWhatsError] = useState('');

    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

    // Verificar se já existe uma loja com ID no carrinho ao iniciar
    useEffect(() => {
        const cartData = JSON.parse(localStorage.getItem('cart'));
        if (cartData?.cart?.loja?.id) {
            setIsBuying(true);
        }
    }, []);

    const qtfcr = (ope, data) => {
        let cartDummy = JSON.parse(localStorage.getItem('cart'))
        if (!cartDummy || !cartDummy.cart.loja || !cartDummy.cart.loja.id) {
            setModalShow(true);
        } else {
            if (ope === 'plus') {
                let dummyValue = CartAdd(data)
                setCart(dummyValue)
            } else if (ope === 'minus') {
                let dummyValue = CartRmv(data)
                setCart(dummyValue)
            }
        }
    };

    // Função para ordenar produtos conforme a lista fornecida
    const ordemProdutos = [
        // Pipoca
        "Pipoca Amarela 100g Tamanho Família",
        "Pipoca Branca 100g Tamanho Família",
        "Pipoca Amarela 30g",
        "Pipoca Doce 30g",
        "Pipoca Branca 30g",
        "Pipoca Amarela 15g",
        "Pipoca Branca 15g",
        // Salgadinhos de Milho
        "Queijo 80g",
        "Cebola na Brasa 80g",
        "Churrasco 80g",
        "Galinha Caipira 80g",
        "Manteiga 30g",
        "Queijo 30g",
        "Cebola 30g",
        "Pizza 30g",
        "Churrasco 30g",
        "Presunto  30g",
        "Galinha Caipira 30g",
        "Pastel de Carne 30g",
        "Bacon  30g",
        "Queijo 12g",
        "Cebola 12g",
        "Churrasco 12g",
        "Galinha caipira 12g",
        // Pellets de Trigo
        "Pellet Bacon 35g",
        "Pellet Costela Suína 35g",
    ];
    function ordenarProdutosPorNome(produtos) {
        return produtos.slice().sort((a, b) => {
            const idxA = ordemProdutos.findIndex(nome => nome.trim().toLowerCase() === a.name.trim().toLowerCase());
            const idxB = ordemProdutos.findIndex(nome => nome.trim().toLowerCase() === b.name.trim().toLowerCase());
            if (idxA === -1 && idxB === -1) return 0;
            if (idxA === -1) return 1;
            if (idxB === -1) return -1;
            return idxA - idxB;
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await productsPublicShop();
                if (response.status === 200) {
                    const result = response.data.result;
                    if (result && result.store) {
                        setShopper(result.store);
                    }
                    if (result && result.products) {
                        // Ordenar produtos conforme a lista
                        setProducts(ordenarProdutosPorNome(result.products));
                    }
                    setLoading(false);
                }
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (shopperId !== '-') {
            const selectedProduct = products.find(p => p.id === shopperId);
            if (selectedProduct) {
                setProduct(selectedProduct);
                setModalProduct(true);
            }
        }
    }, [shopperId, products]);

    useEffect(() => {
        let dummy = JSON.stringify(cart)
        localStorage.setItem('cart', dummy)
    }, [cart]);

    const shopConfirm = () => {
        const cartDummy = JSON.parse(localStorage.getItem('cart')) || {};
        cartDummy.cart = cartDummy.cart || {};

        // Garantir que todas as informações da loja sejam mantidas
        if (shopper && shopper.id) {
            cartDummy.cart.loja = shopper;
            cartDummy.cart.status = 'em uso';
            cartDummy.cart.itens = [];
            localStorage.setItem('cart', JSON.stringify(cartDummy));
            setIsBuying(true);
            setModalShow(false);
        }
    };

    useEffect(() => {
        if (localStorage.cart) {
            const cartDummy = JSON.parse(localStorage.cart);
            let somaQuantidades = 0;
            if (cartDummy.cart.itens && cartDummy.cart.itens.length > 0) {
                cartDummy.cart.itens.forEach(item => {
                    if (item.hasOwnProperty('quantidade')) {
                        somaQuantidades += item.quantidade;
                    }
                });
            }
            setQtd(somaQuantidades);
        } else {
            setQtd(0);
        }
    }, [cart]);

    useEffect(() => {
        if (shopper && shopper.id) {
            shopConfirm();
        }
    }, [shopper]);
    
    const handleStoreFilter = (value, Page, PerPage) => {
        const storeFilter = async () => {
            try {
                const response = await productsPublicShop(value, Page, PerPage);
                if (response.status === 200) {
                    setProducts(response.data.result);
                    setOsSearch(true);
                    setLastSearch(value);
                    setModalSearch(false);
                }
            } catch (error) {
                console.error("Erro ao filtrar lojas:", error);
            }
        };
        storeFilter();
    };

    const lojaId = localStorage.cart ? JSON.parse(localStorage.cart) : { cart: {} }

    const onRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    // Função de formatação igual ao cadastro
    const formatPhone = (value) => {
        const numbers = value.replace(/\D/g, '');
        let formatted = numbers;
        if (numbers.length >= 11) {
            formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}.${numbers.slice(7, 11)}`;
        } else if (numbers.length >= 7) {
            formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}.${numbers.slice(7)}`;
        } else if (numbers.length >= 2) {
            formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
        }
        return formatted;
    };

    // Função para enviar acesso via WhatsApp
    const handleSendWhats = async () => {
        setWhatsLoading(true);
        setWhatsError('');
        setWhatsSuccess(false);
        // Extrair apenas números e garantir DDI 55
        let phoneForApi = whatsPhone.replace(/\D/g, '');
        if (!phoneForApi.startsWith('55')) {
            phoneForApi = '55' + phoneForApi;
        }
        // Remover o primeiro 9 após o DDD (após os dois primeiros dígitos)
        if (phoneForApi.length >= 13) {
            const ddd = phoneForApi.slice(0, 4); // 55 + DDD
            let rest = phoneForApi.slice(4);
            if (rest.startsWith('9')) {
                rest = rest.slice(1);
            }
            phoneForApi = ddd + rest;
        }
        try {
            const response = await fetch('https://bot.pskeromais.com.br/api/login-access', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone: phoneForApi })
            });
            if (response.ok) {
                setWhatsSuccess(true);
            } else {
                setWhatsError('Erro ao enviar acesso. Tente novamente.');
            }
        } catch (e) {
            setWhatsError('Erro de conexão. Tente novamente.');
        }
        setWhatsLoading(false);
    };

    const formatCPF = (value) => {
        const numbers = value.replace(/\D/g, '').slice(0, 11);
        if (numbers.length <= 3) {
            return numbers;
        }
        if (numbers.length <= 6) {
            return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
        }
        if (numbers.length <= 9) {
            return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
        }
        return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
    };

    const formatCEP = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length >= 8) {
            return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
        }
        return numbers;
    };

    const handleRegisterInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'username') {
            // Permitir apenas letras e números, sem espaços ou sinais
            const sanitized = value.replace(/[^a-zA-Z0-9]/g, '');
            setRegisterData(prev => ({ ...prev, username: sanitized }));
            return;
        }
        if (name === 'phone') {
            const formattedPhone = formatPhone(value);
            setFormattedData(prev => ({ ...prev, phone: formattedPhone }));

            // Formatação especial para o telefone antes de salvar
            let phoneForStorage = value.replace(/\D/g, '');
            // Remove o 9 extra se existir (considerando que está depois do DDD)
            if (phoneForStorage.length >= 11) {
                const ddd = phoneForStorage.slice(0, 2);
                const rest = phoneForStorage.slice(2);
                if (rest.startsWith('9')) {
                    phoneForStorage = ddd + rest.slice(1);
                }
            }
            // Adiciona o 55 no início se não existir
            if (!phoneForStorage.startsWith('55')) {
                phoneForStorage = '55' + phoneForStorage;
            }

            setRegisterData(prev => ({ ...prev, phone: phoneForStorage }));
        } else if (name === 'taxId') {
            const formattedCPF = formatCPF(value);
            setFormattedData(prev => ({ ...prev, taxId: formattedCPF }));
            setRegisterData(prev => ({ ...prev, taxId: value.replace(/\D/g, '').slice(0, 11) }));
            // Validação do CPF
            if (value.replace(/\D/g, '').length === 11) {
                setCpfValid(isValidCPF(value));
            } else {
                setCpfValid(true);
            }
        } else if (name === 'zipcode') {
            const formattedCEP = formatCEP(value);
            setFormattedData(prev => ({ ...prev, zipcode: formattedCEP }));
            setRegisterData(prev => ({
                ...prev,
                address: {
                    ...prev.address,
                    zipcode: value.replace(/\D/g, '')
                }
            }));
        } else if (name.startsWith('address.')) {
            const addressField = name.split('.')[1];
            setRegisterData(prev => ({
                ...prev,
                address: {
                    ...prev.address,
                    [addressField]: value
                }
            }));
        } else {
            setRegisterData(prev => ({ ...prev, [name]: value }));
        }

        validateForm();
    };

    const validateForm = () => {
        const isValid =
            registerData.name.length > 0 &&
            registerData.phone.replace(/\D/g, '').length >= 10 &&
            recaptchaToken !== null;

        setIsFormValid(isValid);
    };

    useEffect(() => {
        validateForm();
    }, [registerData, recaptchaToken]);

    const sendCreateCustomer = async () => {
        try {
            // Formatar a data de nascimento para YYYY-MM-DDT00:00:00-03:00
            const [birthYear, birthMonth, birthDay] = registerData.birthDate.split('-');
            const formattedBirthDate = `${birthYear}-${birthMonth}-${birthDay}T00:00:00-03:00`;

            const formattedData = {
                name: registerData.name,
                phone: registerData.phone.replace(/\D/g, '').replace(/^9/, ''),
                taxId: '00000000000',
                username: registerData.phone.replace(/\D/g, '').replace(/^9/, ''),
                password: registerData.phone.replace(/\D/g, '').replace(/^9/, ''),
                email: 'email@email.com',
                birthDate: "2000-05-20T00:00:00Z",
                captcha: recaptchaToken,
                images: [],
                address: {
                    number: registerData.address.number,
                    street: registerData.address.street,
                    city: registerData.address.city,
                    state: registerData.address.state,
                    zipcode: registerData.address.zipcode.replace(/\D/g, '')
                }
            };

            const response = await createCustomer(formattedData);
            if (response.status === 200) {
                setRegisterStatus('success');
            } else {
                setRegisterStatus('error');
                setErrorMessage('Falha ao criar conta. Tente novamente.');
            }
        } catch (error) {
            console.error("Erro ao criar cliente:", error);
            setRegisterStatus('error');
            console.log('error.response')
            console.log(error.response)
            setErrorMessage(error.response?.data[0].errorMessage || 'Erro ao criar conta. Tente novamente.');
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (!isFormValid) return;
        await sendCreateCustomer();
    };

    const handleAutoLogin = async () => {
        try {
            if (!recaptchaToken) {
                setErrorMessage('É necessário realizar o teste do reCAPTCHA para logar.');
                return;
            }

            dispatch(loadingToggleAction(true));
            dispatch(loginAction(registerData.phone, registerData.phone, recaptchaToken));
            setModalAuth(false);
            setRegisterStatus(null);
            setAuthStep('initial');
            navigate('/');
        } catch (error) {
            console.error("Erro no login automático:", error);
            setErrorMessage('Erro ao fazer login automático. Tente fazer login manualmente.');
            setAuthStep('login');
        }
    };

    const handleLogin = async (e, isAutoLogin = false) => {
        if (!isAutoLogin) {
            e.preventDefault();
        }

        if (!recaptchaToken) {
            alert('É necessário realizar o teste do reCAPTCHA para logar.');
            return;
        }

        try {
            dispatch(loadingToggleAction(true));
            dispatch(loginAction(loginData.username, loginData.password, recaptchaToken));
            setModalAuth(false);
            navigate('/');
        } catch (error) {
            console.error("Erro no login:", error);
            alert("Erro ao realizar login. Tente novamente.");
        }
    };

    const handleScroll = (e) => {
        const element = e.target;
        const showButton = element.scrollHeight - element.scrollTop > element.clientHeight + 50;
        setShowScrollButton(showButton);
    };

    const scrollToBottom = () => {
        if (formRef.current) {
            formRef.current.scrollTo({
                top: formRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    };

    // Função para validar CPF
    function isValidCPF(cpf) {
        cpf = cpf.replace(/\D/g, '');
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
        let sum = 0;
        for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (sum % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(9))) return false;
        sum = 0;
        for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (sum % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(10))) return false;
        return true;
    }

    // Função para obter a quantidade de um produto no carrinho
    const getQtdInCart = (productId) => {
        const cartDummy = JSON.parse(localStorage.getItem('cart'));
        if (cartDummy && cartDummy.cart && cartDummy.cart.itens) {
            const item = cartDummy.cart.itens.find(i => i.produto && i.produto.id === productId);
            return item ? item.quantidade : 0;
        }
        return 0;
    };

    // IDs e nomes das categorias (Pipoca primeiro)
    const categorias = [
        { id: "d34e4917-4cdb-442e-90e8-e68adc781807", nome: "Pipoca" },
        { id: "54bd475f-7438-49fb-9967-ef0d2ba32c46", nome: "Salgadinho de Milho" },
        { id: "219cbfd3-dc40-4547-ba16-b68ee3cbb758", nome: "Salgadinho de Trigo" },
    ];
    // Pesos do mais pesado para o mais leve
    const pesos = [100, 80, 35, 30, 15, 12];

    // Função para mapear o nome da categoria para o título exibido
    const nomeCategoriaExibicao = {
        'd34e4917-4cdb-442e-90e8-e68adc781807': 'PIPOCA',
        '54bd475f-7438-49fb-9967-ef0d2ba32c46': 'SALGADINHO DE MILHO',
        '219cbfd3-dc40-4547-ba16-b68ee3cbb758': 'PELLET DE TRIGO',
    };

    const nomeCategoriaExibicaoTitle = {
        'd34e4917-4cdb-442e-90e8-e68adc781807': 'PIPOCAS',
        '54bd475f-7438-49fb-9967-ef0d2ba32c46': 'SALGADINHOS DE MILHO',
        '219cbfd3-dc40-4547-ba16-b68ee3cbb758': 'PELLETS DE TRIGO',
    };

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <nav style={{ width: '100%', position: 'fixed', top: 0, zIndex: 99 }}>
                <div style={{ padding: 6, width: '100%', display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(18, 176, 81)', gap: 9 }}>
                    <img src={logo} style={{ width: 150 }} />
                    <a
                        onClick={() => setModalAuth(true)}
                        style={{
                            marginTop: 6,
                            borderRadius: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            color: 'black',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#25d366',
                            height: 60,
                            width: 60,
                            cursor: 'pointer',
                            textAlign: 'center',
                            fontSize: 10
                        }}
                    >
                        <i class="bi bi-box-arrow-in-right" style={{ fontSize: 17 }} />
                        <span style={{ lineHeight: '13px' }}>entrar</span>
                    </a>
                    <a
                        onClick={() => cart.cart.itens.length > 0 ? setModalAuth(true) : null}
                        style={{
                            marginTop: 6,
                            borderRadius: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            color: cart.cart.itens.length > 0 ? 'black' : 'white',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: cart.cart.itens.length > 0 ? 'rgb(255 240 0)' : 'green',
                            height: 60,
                            width: 60,
                            cursor: 'pointer',
                            textAlign: 'center',
                            fontSize: 10
                        }}
                    >
                        <i className="bi bi-basket2" style={{ fontSize: 17 }} />
                        <span style={{ lineHeight: '13px' }}>encerrar pedido</span>
                    </a>
                </div>
            </nav>
            {/*quantificador dinâmico*/}
            {
                qtd !== 0 ?
                    <span style={{ display: 'flex', justifyContent: 'center', position: 'absolute', left: 'calc(50% + 135px)', top: '60px', zIndex: '9999', width: 20, height: 20, position: 'fixed', backgroundColor: 'rgb(60, 84, 255)', marginRight: -160, borderRadius: '100%', fontSize: 12, paddingTop: 2, color: 'white', }}>
                        {qtd}
                    </span>
                    : qtd === 0 ?
                        null
                        : null
            }
            <div
                className="row"
                style={{
                    backgroundColor: "rgb(210 216 231)",
                    marginTop: 40,
                    paddingTop: 130,
                }}
            >
                <div className="row" style={{ margin: "0 auto", maxWidth: 800 }}>
                    {/* balão em mobile */}
                    {!isDesktop && (
                        <div className="col-md-8" style={{ position: "relative" }}>
                            <div
                                style={{
                                    backgroundColor: "white",
                                    borderRadius: 20,
                                    padding: "20px 25px",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                                    position: "relative",
                                    marginBottom: 40, // dá espaço pra perninha
                                }}
                            >
                                <h3 style={{ marginBottom: 10 }}>🍽️ Faça o seu pedido</h3>
                                <h5 style={{ color: "rgb(60, 84, 255)" }}>
                                    Ele será enviado automaticamente para as{" "}
                                    <b>lojas e distribuidores parceiros</b> mais próximos 🛍️
                                </h5>
                                <ul
                                    style={{
                                        listStyle: "none",
                                        paddingLeft: 0,
                                        marginTop: 10,
                                        lineHeight: "1.8em",
                                    }}
                                >
                                    <li>✅ Um parceiro irá aceitar o seu pedido</li>
                                    <li>🚚 A entrega será feita diretamente no seu endereço</li>
                                    <li>😋 Depois é só aproveitar e se deliciar!</li>
                                </ul>

                                {/* perninha pra baixo no mobile */}
                                <div
                                    style={{
                                        position: "absolute",
                                        left: "50%",
                                        bottom: -20,
                                        transform: "translateX(-50%)",
                                        width: 0,
                                        height: 0,
                                        borderLeft: "10px solid transparent",
                                        borderRight: "10px solid transparent",
                                        borderTop: "20px solid white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {/* imagem */}
                    <div className="col-md-4" style={{justifyContent: "center"}}>
                        <img style={{ width: "100%", maxWidth: 220 }} src={superkeroexplica} />
                    </div>

                    {/* balão em desktop (só aparece >=768px) */}
                    {isDesktop && (
                        <div className="col-md-8" style={{ position: "relative" }}>
                            <div
                                style={{
                                    backgroundColor: "white",
                                    borderRadius: 20,
                                    padding: "20px 25px",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                                    position: "relative",
                                }}
                            >
                                <h3 style={{ marginBottom: 10 }}>🍽️ Faça o seu pedido</h3>
                                <h5 style={{ color: "rgb(60, 84, 255)" }}>
                                    Ele será enviado automaticamente para as{" "}
                                    <b>lojas e distribuidores parceiros</b> mais próximos 🛍️
                                </h5>
                                <ul
                                    style={{
                                        listStyle: "none",
                                        paddingLeft: 0,
                                        marginTop: 10,
                                        lineHeight: "1.8em",
                                    }}
                                >
                                    <li>✅ Um parceiro irá aceitar o seu pedido</li>
                                    <li>🚚 A entrega será feita diretamente no seu endereço</li>
                                    <li>😋 Depois é só aproveitar e se deliciar!</li>
                                </ul>

                                {/* perninha pro lado no desktop */}
                                <div
                                    style={{
                                        position: "absolute",
                                        left: -20,
                                        top: "40%",
                                        width: 0,
                                        height: 0,
                                        borderTop: "10px solid transparent",
                                        borderBottom: "10px solid transparent",
                                        borderRight: "20px solid white",
                                        boxShadow: "-1px 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>

            </div>

            <div className="row" style={{ flexDirection: 'column', gap: '27px', backgroundColor: 'rgb(210 216 231)' }}>
                {
                    lojaSelecionada !== null ?
                        <div className="col-xl-12" style={{ maxWidth: '400px', margin: '0 auto', color: 'black', marginTop: 3 }}>
                            {shopper.deliveryTax > 0 ?
                                <span className='d-flex flex-wrap flex-column justify-content-center'>
                                    <div style={{ width: 130, margin: '0 auto', textAlign: 'center', color: 'gray' }}>
                                        - taxa de entrega -
                                        <br />
                                        <h3 style={{ margin: 0, padding: 4, borderRadius: 4, padding: 6, backgroundColor: 'white' }}>{shopper.deliveryTax.toFixed(2)} RS</h3>
                                    </div>
                                </span>
                                : <span className='d-flex flex-wrap flex-column justify-content-center text-center'>
                                    <span style={{ color: 'white', padding: 6 }}>
                                        sem taxa de entrega
                                    </span>
                                </span>
                            }
                        </div>
                        : null
                }

                <div className="col-xl-12" style={{ maxWidth: 800, padding: 0, margin: '0 auto' }}>
                    {products.length !== 0 ? (
                        isLargeScreen ? (
                            categorias.map((cat) => {
                                const pesosDisponiveis = pesos.filter(peso => products.some(p => p.categoryId === cat.id && p.weight === peso && p.stock !== 0));
                                if (pesosDisponiveis.length === 0) return null;
                                return (
                                    <div key={cat.id} style={{ marginBottom: 32 }}>
                                        <h3 style={{ padding: '8px', borderRadius: '3px', backgroundColor: 'rgb(60 84 255)', color: 'white', textAlign: 'center', margin: '16px 0 20px 0', textTransform: 'uppercase', letterSpacing: 1 }}>{nomeCategoriaExibicaoTitle[cat.id]}</h3>
                                        <ul className="btn-reveal-trigger row" style={{ padding: 0 }}>
                                            {pesosDisponiveis.map((peso) => {
                                                const produtosFiltrados = products.filter(
                                                    (Data) => Data.weight === peso && Data.stock !== 0 && Data.categoryId === cat.id
                                                );
                                                if (produtosFiltrados.length === 0) return null;
                                                return (
                                                    <React.Fragment key={peso}>
                                                        {/* Removido o título de peso */}
                                                        {produtosFiltrados.map((Data) => (
                                                            <li className="col-sm-6 col-md-4" style={{ marginBottom: 6, borderRadius: 6 }} key={Data.id}>
                                                                <div className="p-3" style={{ boxShadow: 'rgb(177 177 177) 1px 1px 4px', backgroundColor: 'white', marginBottom: 16, minHeight: 490 }}>
                                                                    <span style={{ display: 'flex', flexDirection: 'column', gap: 3, position: 'relative' }}>
                                                                        {Data.images.length > 0 ? (
                                                                            <img className="" style={{ width: '100%' }} src={'https://core.pskeromais.com.br/' + Data.images[0].url} />
                                                                        ) : (
                                                                            <span style={{ width: '100%', height: 200, backgroundImage: "gray", margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)' }}>
                                                                                <i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
                                                                            </span>
                                                                        )}
                                                                        <span className="mb-0 fs--1" style={{ width: '100%', textAlign: 'center', fontSize: 10 }}>pack com 10 unid.</span>
                                                                        <div style={{ width: '100%' }}><br />
                                                                            <h3 className="mb-0 fs--1" style={{ width: '100%', textAlign: 'center' }}>{Data.name}, {Data.weight}g</h3>
                                                                            <span style={{ fontSize: '15px', fontWeight: 'bold', margin: '4px auto', display: 'block', textAlign: 'center' }}>{nomeCategoriaExibicao[cat.id]}</span>
                                                                        </div>
                                                                        <span style={{ maxWidth: '100px', width: '100%', margin: '6px auto', backgroundColor: 'rgb(241, 241, 241)', padding: 6, borderRadius: '3px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column", position: 'relative' }}>
                                                                            {Data.salePrice > Data.onSalePrice ? (
                                                                                <i style={{ margin: '0 4px', textDecoration: 'line-through', color: '#a0a0a0' }}>{Data.salePrice.toFixed(2) + ' R$'}</i>
                                                                            ) : null}
                                                                            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{Data.onSalePrice.toFixed(2) + ' R$'}</span>
                                                                            {/*Data.salePrice > Data.onSalePrice ? (
                                                                                <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontWeight: 'bold', backgroundColor: '#F54749', color: 'white', width: 60, height: 60, padding: 10, borderRadius: '100%', fontSize: 18, position: 'absolute', top: '-15px', right: '-40px' }}>
                                                                                    <span style={{ height: '18px' }}>{calculateDiscountPercentage(Data.salePrice, Data.onSalePrice) + '%'}</span>
                                                                                    <span style={{ height: '18px', fontWeight: 'normal' }}>OFF</span>
                                                                                </span>
                                                                            ) : null*/}
                                                                        </span>
                                                                    </span>
                                                                    {isBuying ? (
                                                                        <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                            <button onClick={() => qtfcr('minus', Data)} className="btn btn-primary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                                <i className="bi bi-dash" style={{ fontSize: 20 }}></i>
                                                                            </button>
                                                                            <span style={{
                                                                                minWidth: 36,
                                                                                minHeight: 36,
                                                                                width: 38,
                                                                                height: 38,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                borderRadius: '50%',
                                                                                background: '#e0e0e0',
                                                                                fontWeight: 'bold',
                                                                                fontSize: 22,
                                                                                color: '#333',
                                                                                margin: '0 6px',
                                                                                border: '2px solid #bdbdbd',
                                                                            }}>{getQtdInCart(Data.id)}</span>
                                                                            <button onClick={() => qtfcr('plus', Data)} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                                                <i className="bi bi-plus" style={{ fontSize: 20 }}></i>
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                            <button onClick={() => setModalShow(!modalShow)} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto">
                                                                                fazer pedido
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                    <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                                        <button onClick={() => setShopperId(Data.id)} className="btn btn-primary-outline border border-primary text-primary py-1 px-3 mt-2 mr-auto ml-auto" style={{ maxWidth: 100 }}>
                                                                            produto
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                );
                            })
                        ) : (
                            categorias.map((cat) => {
                                const pesosDisponiveis = pesos.filter(peso => products.some(p => p.categoryId === cat.id && p.weight === peso && p.stock !== 0));
                                if (pesosDisponiveis.length === 0) return null;
                                return (
                                    <div key={cat.id} style={{ marginBottom: 32 }}>
                                        <h3 style={{ padding: '8px', borderRadius: '3px', backgroundColor: 'rgb(60 84 255)', color: 'white', textAlign: 'center', margin: '16px 0 8px 0', textTransform: 'uppercase', letterSpacing: 1 }}>{nomeCategoriaExibicao[cat.id]}</h3>
                                        {pesosDisponiveis.map((peso) => {
                                            const produtosFiltrados = products.filter(
                                                (product) => product.weight === peso && product.stock !== 0 && product.categoryId === cat.id
                                            );
                                            if (produtosFiltrados.length === 0) return null;
                                            return (
                                                <React.Fragment key={peso}>
                                                    {/* Removido o título de peso */}
                                                    <SwiperCTNProducts products={produtosFiltrados.map(prod => ({ ...prod, name: prod.name + ', ' + prod.weight + 'g' }))} setModalShows={() => setModalShow(!modalShow)} isBuying={isBuying} qtfcrMinus={(Data) => qtfcr('minus', Data)} qtfcrPlus={(Data) => qtfcr('plus', Data)} getQtdInCart={getQtdInCart} />
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                );
                            })
                        )
                    ) : null}
                </div>
            </div>
            <Modal className="custom-modal fade d-flex align-items-center justify-content-center " show={modalShow}>
                <button onClick={() => setModalShow(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <i className="bi bi-basket" style={{ fontSize: 30 }}></i>
                    <h2>inciar compras?</h2>
                    <br />
                    <div onClick={() => setModalShow(false)} className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button onClick={() => shopConfirm()} className='btn btn-primary'>
                            começar compras
                        </button>
                        <button className='btn btn-light'>
                            cancelar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal className="custom-modal fade d-flex align-items-center justify-content-center " show={modalProduct}>
                <button onClick={() => { setModalProduct(false); setShopperId('-') }} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    {product.name ?
                        <>
                            <div className="p-3">
                                <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    {
                                        product.images.length > 0 ?
                                            <img className="" style={{ width: 130 }} src={'https://core.pskeromais.com.br/' + product.images[0].url} />
                                            : <span style={{
                                                width: 130,
                                                height: 80,
                                                backgroundImage: "gray",
                                                margin: '0 auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)'
                                            }}>
                                                <i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
                                            </span>
                                    }
                                </span>
                            </div>
                            <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <div className="media d-flex justify-content-between">
                                    <div>
                                        <br />
                                        <h3 className="mb-0 fs--1">
                                            {product.name}
                                        </h3>
                                    </div>
                                </div>
                                <hr />
                                <p style={{ textIndent: '24px', textAlign: 'justify' }}>
                                    {product.description}
                                </p>
                                <span style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                    <span>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-stack" ></i> peso
                                        </span>
                                        <br />
                                        <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                            {product.weight + ' g'}
                                        </span>
                                    </span>
                                    <span>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-wallet2"></i> preço:
                                        </span>
                                        <span style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                                            <span style={{ width: '50%' }}>
                                                <label style={{ margin: '0' }}>preço</label>
                                                <hr style={{ margin: '2px 0' }} />
                                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{product.onSalePrice + ' R$'}</span>
                                            </span>
                                        </span>
                                    </span>
                                    <br />
                                    <span>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-clipboard" ></i> tipo
                                        </span>
                                        <br />
                                        <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                            {
                                                product.categoryId === "54bd475f-7438-49fb-9967-ef0d2ba32c46" ?
                                                    'Salgadinho de Milho'
                                                    : product.categoryId === "219cbfd3-dc40-4547-ba16-b68ee3cbb758" ?
                                                        'Salgadinho de Trigo'
                                                        : product.categoryId === "d34e4917-4cdb-442e-90e8-e68adc781807" ?
                                                            'Pipoca'
                                                            : null
                                            }
                                        </span>
                                    </span>
                                    {/* <span style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <span style={{ color: 'rgb(245, 71, 73)' }}>
                                            <i className="bi bi-archive"></i> estoque:
                                        </span>
                                        {Data.Store ? Data.Store : <span style={{ color: 'red' }}>- sem estoque -</span>}
                                    </span> */}
                                </span>
                            </span>
                        </>
                        : null}
                    <br />
                    <div onClick={() => { setModalProduct(false); setShopperId('-') }} className='d-flex align-items-center justify-content-center flex-row' style={{ gap: 4 }}>
                        <button className='btn btn-light'>
                            fechar
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal show={modalSearch}>
                <button onClick={() => setModalSearch(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <span
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'column',
                        justifyContent: 'spaceBetween',
                        width: '100%',
                        margin: '10px 0',
                        justifyContent: 'space-around',
                        justifyContent: 'center',
                        alignContent: 'center'
                    }}
                >
                    <span
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                            justifyContent: 'spaceBetween',
                            justifyContent: 'space-around',
                            padding: '14px',
                            justifyContent: 'center',
                            gap: '10px',
                            border: '1px #f6f6f6 solid'
                        }}
                    >
                        <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            <h5 className="" style={{ margin: 0 }}><i className="fa-solid fa-magnifying-glass"></i></h5>
                            <h5 className="text-primary" style={{ margin: 0 }}>Pesquisar Loja</h5>
                        </span>
                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                            {searchSteps === 'name' ?
                                <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                                    <input onChange={(e) => setProductNameSearch(e.target.value)} value={productNameSearch.length > 0 ? productNameSearch.length : ''} placeholder="pesquisar por nome" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                                    <button className={`btn btn-light`} style={{ fontSize: 12 }} onClick={() => handleStoreFilter(searchValueType, productNameSearch)}>buscar</button>
                                </span>
                                : searchSteps === 'address' ?
                                    <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                                            <input placeholder="pesquisar por endereço" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                                            <select style={{ width: '120px', textAlign: 'center', height: 40, color: 'gray' }}>
                                                <option onClick={(e) => { setValueType('street') }} >rua</option>
                                                {/* <option>número</option> */}
                                                <option onClick={(e) => setValueType('neighborhood')}>bairro</option>
                                                <option onClick={(e) => setValueType('city')}>cidade</option>
                                            </select>
                                        </span>
                                        <button
                                            className={`btn btn-light`}
                                            style={{ fontSize: 12 }}>
                                            buscar
                                        </button>
                                    </span>
                                    : null}
                        </span>
                    </span>
                </span>
            </Modal>
            <Modal className="custom-modal fade d-flex align-items-center justify-content-center" show={modalAuth}>
                <div
                    ref={formRef}
                    onScroll={handleScroll}
                    className='d-flex align-items-center flex-column p-4'
                    style={{
                        minHeight: 300,
                        width: '100%',
                        minWidth: 350,
                        maxWidth: 400,
                        maxHeight: 500,
                        overflow: 'scroll',
                        position: 'relative',
                        paddingBottom: 70
                    }}
                >
                    {authStep === 'register' && (
                        <div
                            style={{
                                position: 'fixed',
                                bottom: 42,
                                right: 0,
                                left: 350,
                                display: 'flex',
                                justifyContent: 'center',
                                zIndex: 1000,
                                width: 40,
                                margin: '0 auto'
                            }}
                        >
                            <button
                                onClick={scrollToBottom}
                                className="btn"
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    backgroundColor: 'rgb(60, 84, 255)',
                                    color: 'white'
                                }}
                            >
                                <i className="bi bi-arrow-down" style={{ fontSize: 20 }}></i>
                            </button>
                        </div>
                    )}

                    {authStep === 'initial' && (
                        <>
                            <i className="bi bi-person-circle" style={{ fontSize: 40, marginBottom: 20 }}></i>
                            <h3 className="text-center mb-4">Bem-vindo!</h3>
                            <div className="d-flex flex-column gap-3 w-100">
                                <button
                                    className="btn btn-primary btn-lg"
                                    onClick={() => setAuthStep('login')}
                                >
                                    Fazer Login
                                </button>
                                <button
                                    className="btn btn-secondary btn-lg"
                                    onClick={() => setAuthStep('register')}
                                >
                                    Criar Conta
                                </button>
                                <button
                                    className="btn btn-light"
                                    onClick={() => setModalAuth(false)}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </>
                    )}

                    {authStep === 'login' && (
                        <>
                            <button
                                onClick={() => setAuthStep('initial')}
                                className='btn btn-light p-1 position-absolute'
                                style={{ left: 10, top: 10 }}
                            >
                                <i className="bi bi-arrow-left"></i> Voltar
                            </button>
                            <h3 className="text-center mb-4">Login</h3>
                            <hr />
                            <div className="mb-3 mt-3">
                                <label className="mb-1"><strong>Receber acesso por WhatsApp</strong></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="(99) 99999.9999"
                                    value={formatPhone(whatsPhone)}
                                    onChange={e => {
                                        // Permitir só números
                                        const val = e.target.value.replace(/\D/g, '');
                                        setWhatsPhone(val);
                                    }}
                                    maxLength={16}
                                />
                                <button
                                    className="btn btn-success w-100 mt-2"
                                    onClick={handleSendWhats}
                                    disabled={whatsLoading || whatsPhone.replace(/\D/g, '').length < 10}
                                >
                                    {whatsLoading ? 'Enviando...' : 'Enviar pro WhatsApp'}
                                </button>
                                {whatsLoading && (
                                    <div className="text-center mt-2">Aguardando resposta...</div>
                                )}
                                {whatsSuccess && (
                                    <div className="alert alert-success mt-2">Acesso enviado com sucesso! Verifique seu WhatsApp.</div>
                                )}
                                {whatsError && (
                                    <div className="alert alert-danger mt-2">{whatsError}</div>
                                )}
                            </div>
                        </>
                    )}

                    {authStep === 'register' && registerStatus === 'success' && (
                        <div className="text-center">
                            <i className="bi bi-check-circle-fill text-success" style={{ fontSize: 50 }}></i>
                            <h3 className="mt-3">Cadastro Realizado!</h3>
                            <p>Sua conta foi criada com sucesso.</p>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                <ReCAPTCHA
                                    sitekey="6LdLwaQqAAAAAL4Ktttukdp8qXT5pcHHd4PFbtOS"
                                    onChange={onRecaptchaChange}
                                />
                            </div>
                            <button
                                className="btn btn-primary mt-3"
                                onClick={handleAutoLogin}
                                disabled={!recaptchaToken}
                            >
                                Entrar no Sistema
                            </button>
                        </div>
                    )}

                    {authStep === 'register' && registerStatus === 'error' && (
                        <div className="text-center">
                            <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: 50 }}></i>
                            <h3 className="mt-3">Erro no Cadastro</h3>
                            <p className="text-danger">{errorMessage}</p>
                            <button
                                className="btn btn-secondary mt-3"
                                onClick={() => setRegisterStatus(null)}
                            >
                                Tentar Novamente
                            </button>
                        </div>
                    )}

                    {authStep === 'register' && !registerStatus && (
                        <>
                            <button
                                onClick={() => setAuthStep('initial')}
                                className='btn btn-light p-1 position-absolute'
                                style={{ left: 10, top: 10 }}
                            >
                                <i className="bi bi-arrow-left"></i> Voltar
                            </button>
                            <h3 className="text-center mb-4">Criar Conta</h3>
                            <form onSubmit={handleRegister} className="w-100">
                                <div className="mb-3">
                                    <h4>Dados Básicos</h4>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Nome Completo</strong></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                value={registerData.name}
                                                onChange={handleRegisterInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Telefone</strong></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="phone"
                                                value={formattedData.phone}
                                                onChange={handleRegisterInputChange}
                                                maxLength={16}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mb-3">
                                    <h4>Endereço</h4>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>CEP</strong></label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="zipcode"
                                                value={formattedData.zipcode}
                                                onChange={handleRegisterInputChange}
                                                maxLength={9}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Rua</strong></label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="address.street"
                                                value={registerData.address.street}
                                                onChange={handleRegisterInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Número</strong></label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="address.number"
                                                value={registerData.address.number}
                                                onChange={handleRegisterInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Cidade</strong></label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="address.city"
                                                value={registerData.address.city}
                                                onChange={handleRegisterInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="mb-1"><strong>Estado</strong></label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="address.state"
                                                value={registerData.address.state}
                                                onChange={handleRegisterInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                    <ReCAPTCHA
                                        sitekey="6LdLwaQqAAAAAL4Ktttukdp8qXT5pcHHd4PFbtOS"
                                        onChange={onRecaptchaChange}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary w-100"
                                    disabled={!isFormValid}
                                >
                                    Cadastrar e Entrar
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </Modal>
            <span style={{ zIndex: 9999, width: '100%', height: '100vh', backgroundColor: 'rgba(41 ,180,226,0.6)', position: 'absolute', top: 0, right: 0, display: loading ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }} >
                <i id="loading-arrow-in-circle" class="bi bi-arrow-clockwise" style={{ color: 'white', fontSize: 75 }}></i>
            </span>
            {/* Botão Fale Conosco fixo */}
            <a
                href="https://wa.me/558596180407"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    zIndex: 99999,
                    background: '#25d366',
                    color: 'white',
                    borderRadius: 30,
                    padding: '12px 24px',
                    fontWeight: 'bold',
                    fontSize: 18,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    textDecoration: 'none',
                }}
            >
                <i className="bi bi-whatsapp" style={{ fontSize: 22 }}></i> fale conosco
            </a>
        </>
    )
}
export default MenuOut; 
